/* eslint-disable react-hooks/exhaustive-deps */
import CustomButton from "components/CustomButton/CustomButton";
import DisketIcon from "icons/DisketIcon";
import UserIcon2 from "icons/UserIcon2";
import { useEffect, useState } from "react";
import { Container } from "./styles";

const BUTTON_STYLES = {
    variant: "secondary",
    width: "100%"
};

const ActionButtons = ({
    studentList, 
    selectedStudents,
    forValidations: {
        getHasBeenSelectedResponsableStudent,
        getMaxCapacityHasBeenReached
    },
    getIsForUpdatePenalty,
    finalized,
    notActions,
    actions: {
        openTakeStudentAttendanceDialog,
        openPenalizeStudentDialog,
        openDeleteStudentDialog,
        openAddStudentDialog,
        openSaveInformationDialog
    }
}) => {
    const [thereAreStudentsNoCompletlyAdded, setThereAreStudentsNoCompletlyAdded] = useState(false);
    const [hasBeenSelectedResponsableStudent, setHasBeenSelectedResponsableStudent] = useState(false);
    const [maxCapacityHasBeenReached, setMaxCapacityHasBeenReached] = useState(false);
    const [isForUpdatePenalty, setIsForUpdatePenalty] = useState(false);
    const [selectedStudentsAttendanceWasNotTaken, setSelectedStudentsAttendanceWasNotTaken] = useState(false);
    //#region Effects
    useEffect(() => {
        setThereAreStudentsNoCompletlyAdded(getThereAreStudentNoCompletlyAdded());
        setHasBeenSelectedResponsableStudent(getHasBeenSelectedResponsableStudent());
        setIsForUpdatePenalty(getIsForUpdatePenalty());
        setSelectedStudentsAttendanceWasNotTaken(getSelectedStudentsAttendanceWasNotTaken());
    }, [selectedStudents]);
    useEffect(() => {
        setMaxCapacityHasBeenReached(getMaxCapacityHasBeenReached());
    }, [studentList]);
    //#endregion
    //#region Functions
    const getSelectedStudentsAttendanceWasNotTaken = () => {
        return !selectedStudents.every(({ attended }) => attended);
    }
    const getThereAreStudentNoCompletlyAdded = () => {
        return selectedStudents.some(({ saved }) => !saved);
    }
    //#endregion
    const noStudentsSelected = selectedStudents.length === 0;
    const disabledButtons = {
        takeAttendance: (
            finalized ||
            noStudentsSelected || 
            thereAreStudentsNoCompletlyAdded
        ),
        penalty: (
            noStudentsSelected || 
            thereAreStudentsNoCompletlyAdded || 
            selectedStudentsAttendanceWasNotTaken
        ),
        delete: (
            finalized || 
            hasBeenSelectedResponsableStudent || 
            noStudentsSelected
        ),
        add: (
            finalized ||
            maxCapacityHasBeenReached
        )
    };
    return (
        <Container>
            <CustomButton
                {...BUTTON_STYLES}
                icon={<UserIcon2 variant="check"/>} 
                text="Marcar asistencia"
                onClick={openTakeStudentAttendanceDialog}
                disabled={disabledButtons.takeAttendance}/>
            <CustomButton 
                {...BUTTON_STYLES}
                icon={<UserIcon2 variant="cross"/>} 
                text={isForUpdatePenalty ? "Editar sanción(es)" : "Sancionar alumno(s)"}
                onClick={openPenalizeStudentDialog}
                disabled={disabledButtons.penalty}/>
            <CustomButton 
                {...BUTTON_STYLES}
                icon={<UserIcon2 variant="hypen"/>} 
                text="Eliminar alumno(s)"
                onClick={openDeleteStudentDialog}
                disabled={disabledButtons.delete}/>
            <CustomButton 
                {...BUTTON_STYLES}
                icon={<UserIcon2 variant="plus"/>} 
                text="Agregar alumno(s)"
                onClick={openAddStudentDialog}
                disabled={disabledButtons.add}/>
            <CustomButton 
                {...BUTTON_STYLES}
                variant="primary"
                icon={<DisketIcon/>} 
                text="Guardar información"
                onClick={openSaveInformationDialog}
                disabled={notActions}/>
        </Container>
    );
}

export default ActionButtons;